import styled from 'styled-components';

import { fromLarge, fromMedium } from '../../../../styleUtils/mediaQueries';
import { gridColumn, gridRow } from 'styleUtils/grid';

interface Props {
    titleLeft: boolean;
}
export const DescriptionWrapper = styled.div<Props>`
    ${gridRow({ start: 2 })}
    text-align: justify;

    ${fromMedium`
        ${({ titleLeft }): string => `
            ${gridColumn({ start: titleLeft ? 2 : 1, end: 3 })}
            ${gridRow({ start: titleLeft ? 1 : 2, end: titleLeft ? 2 : 3 })}
        `}
    `}

    ${fromLarge`
        ${({ titleLeft }): string => `
            ${!titleLeft && `padding-right: 358px; padding-left: 100px;`}
        `}
    `}
`;
